import { render } from "./GroupTaskDetail.vue?vue&type=template&id=20568b0d"
import script from "./GroupTaskDetail.vue?vue&type=script&lang=js"
export * from "./GroupTaskDetail.vue?vue&type=script&lang=js"

import "./GroupTaskDetail.vue?vue&type=style&index=0&id=20568b0d&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__